import * as React from "react"

const PackageIcon = ({...props}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
    <path fill="#cc9869" d="M56 44.065V17H8v44h48V44.065z" />
    <path fill="#ffcea9" d="M38 61H26v-8l2.968 2 3.033-2L35 55l3-2v8z" />
    <path fill="#f2f2f2" d="M15 37h34v12H15z" />
    <path
      fill="#4d4d4d"
      d="M18 40h3v2h-3zM43 44h3v2h-3zM23 40h10v2H23zM18 44h23v2H18zM35 40h11v2H35z"
    />
    <path fill="#ffcea9" d="M26 17h12v16l-2.968-2-3.033 2L29 31l-3 2V17z" />
    <path
      fill="#936435"
      d="M49.293 24.707 47 22.414l-2.293 2.293-1.414-1.414 3-3a1 1 0 0 1 1.414 0l3 3Z"
    />
    <path
      fill="#936435"
      d="M46 21h2v6h-2zM11 20h8v2h-8zM11 24h12v2H11zM21 20h2v2h-2z"
    />
    <path
      fill="#a67c52"
      d="m56 17-4.095-7H35.857V8h14.878L47.81 3H16.19l-2.925 5h14.878v2H12.095L8 17h48z"
    />
    <path
      fill="#7c5d41"
      d="M35.857 10h16.048l-1.17-2H35.857v2zM28.143 8H13.265l-1.17 2h16.048V8z"
    />
    <path fill="#ffbe92" d="M38 17H26l2-14h8l2 14z" />
    <path d="M7 61a1 1 0 0 0 1 1h48a1 1 0 0 0 1-1V46.064h-2V60H39v-7a1 1 0 0 0-1.555-.832L35 53.8l-2.445-1.63a1 1 0 0 0-1.105 0l-2.476 1.63-2.415-1.627A1 1 0 0 0 25 53v7H9V18h16v15a1 1 0 0 0 1.555.832L29 32.2l2.445 1.63a1 1 0 0 0 1.1 0l2.481-1.63 2.415 1.627A1 1 0 0 0 39 33V18h16v21.968h2V17a.977.977 0 0 0-.151-.5l.014-.008-8.19-14A1 1 0 0 0 47.81 2H16.19a1 1 0 0 0-.863.5l-8.19 14 .014.008A.977.977 0 0 0 7 17Zm20-6.12 1.409.949a1 1 0 0 0 1.109.006L32 54.2l2.447 1.632a1 1 0 0 0 1.11 0L37 54.868V60H27ZM54.256 16H38.867l-.857-6h12.736Zm-7.02-12 2.34 4H37.724l-.571-4ZM28.867 4h6.266l1.714 12h-9.694ZM27 18h10v13.12l-1.409-.949a1 1 0 0 0-1.109-.006L32 31.8l-2.447-1.632a1 1 0 0 0-1.11 0L27 31.132ZM16.764 4h10.083l-.571 4H14.424Zm-3.51 6H25.99l-.857 6H9.744Z" />
    <path d="M55 41.968h2v2.097h-2zM15 50h34a1 1 0 0 0 1-1V37a1 1 0 0 0-1-1H15a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Zm1-12h32v10H16Z" />
    <path d="M18 40h3v2h-3zM43 44h3v2h-3zM23 40h10v2H23zM18 44h23v2H18zM35 40h11v2H35zM47.707 20.293a1 1 0 0 0-1.414 0l-3 3 1.414 1.414L46 23.414V27h2v-3.586l1.293 1.293 1.414-1.414ZM11 20h8v2h-8zM11 24h12v2H11zM21 20h2v2h-2z" />
  </svg>
)

export default PackageIcon